import React, { useState } from "react";
import styled from "styled-components";

const PrintPhotoCollage = ({ collageFrame }) => {
  const [hoveredId, setHoveredId] = useState(null);
  const getRotation = (index) => {
    const angles = [-6, 5, -3, 9, 3, 10];
    return angles[index % angles.length];
  };

  const getLayout = (index) => {
    const columns = 4;
    const row = Math.floor(index / columns);
    const col = index % columns;

    const top = `${row * 5 + Math.random() * 10}%`;
    const left = `${col * 20 + Math.random() * 5}%`;
    const rotate = Math.random() * 10 - 5;

    return { top, left, rotate };
  };

  return (
    <>
    <PrintWrapper>
      <div
        className="collage-containerPrint print-first-image2"
        style={{
          position: "relative",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <StackedCollage>
          {collageFrame.map((frame, index) => {
            const layout = getLayout(frame?.id);
            return (
              <>
              <Photo
                rotation={getRotation(index)}
                zIndex={(index % 6) + 1}
                key={frame?.id}
                className={`photo-frame photo-framePrintCstm ${frame?.className} ${hoveredId === frame?.id ? "hovered" : ""}`}
                style={{
                  width: frame?.width,
                  height: frame?.height,
                  transform: `rotate(${layout.rotate}deg)`,
                  WebkitTransform: `rotate(${frame?.rotate})`,
                  MozTransform: `rotate(${frame?.rotate})`,
                  msTransform: `rotate(${frame?.rotate})`,
                  border: "1px solid #ccc",
                  backgroundColor: "#f8f8f8",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  // overflow: "hidden",
                }}
              >
                {frame?.image ? (
                  <img
                    src={frame?.image}
                    alt={`Collage item ${frame?.id}`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                    className="cursor-pointer"
                  />
                ) : (
                  <div className="upload-placeholder">Collage-{frame?.id}</div>
                )}
              </Photo>
              </> 
            );
          })}
        </StackedCollage>
      </div>
    </PrintWrapper>
    </>
  );
};

export default PrintPhotoCollage;

// Styled Components

const PrintWrapper = styled.div`
  page-break-inside: avoid;
  break-inside: avoid;

  @media print {
    page-break-inside: avoid;
    break-inside: avoid;
    padding-top: 25px;
    padding-bottom: 12px;
  }
`;

const StackedCollage = styled.div`
  position: relative;
  width: 100%;
  max-width: 98%;
  min-height: auto;
  padding: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  page-break-inside: avoid;
`;

const Photo = styled.div`
  position: inherit !important;
  width: 140px;
  padding: 8px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 0px 8px 18px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease, z-index 0.3s ease;
  cursor: pointer;
  transform: rotate(${(props) => props.rotation}deg) !important;
  z-index: ${(props) => props.zIndex};

  &:hover {
    z-index: 999999 !important;
    transform: scale(1.05) rotate(0deg) !important;
  }

  @media (max-width: 1200px) {
    width: 120px;
  }

  @media (max-width: 768px) {
    width: 100px;
  }

  @media (max-width: 480px) {
    width: 80px;
  }

  @media print {
    box-shadow: none;
    border: 1px solid #ccc;
    page-break-inside: avoid;
    break-inside: avoid;
  }
`;

const Image = styled.img`
  width: 100%;
  height: auto;
  display: block;
  border-radius: 4px;
  object-fit: cover;
`;

const ImagePlaceHolder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;
